import { useTranslation } from "react-i18next";
import GenericTable from "./GenericTable";
import { Question } from "../../models/Question";
import useGetQuestionsPaginated from "../../hooks/api/quiz/useGetQuestionsPaginated";
import { useCallback } from "react";
import useDeleteQuestion from "../../hooks/api/question/useDeleteQuestion";
import { useNavigate } from "react-router-dom";

type Props = {
  quizId: number;
};

export default function QuestionsTable({ quizId }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    data: questions,
    isPending,
    isError,
    mutateAsync: fetchQuizzes,
    variables,
  } = useGetQuestionsPaginated(quizId);

  const { mutateAsync: deleteQuestion, isPending: isDeletionPending } =
    useDeleteQuestion();

  const onDeleteConfirm = useCallback(
    (question: Question) => {
      deleteQuestion({ quizId: quizId, questionId: question.id! }).finally(() =>
        fetchQuizzes({ page: variables?.page ?? 0 }),
      );
    },
    [deleteQuestion, fetchQuizzes, quizId, variables?.page],
  );

  return (
    <GenericTable<Question>
      items={questions?.content ?? []}
      headers={[t("forms.description")]}
      rowExtractors={[(question) => question.description]}
      onEditClick={(question) => navigate(`./questions/${question.id}`)}
      onDeleteConfirm={onDeleteConfirm}
      isDeletionPending={isDeletionPending}
      isLoading={isPending}
      isError={isError}
      refetch={fetchQuizzes}
      pagination={questions?.page}
    />
  );
}
